import { ColumnSizingState, Table } from '@tanstack/vue-table';
import { nextTick } from 'vue';

export const updateFirstColumnWidth = async (table: Table<any>, columnId: string) => {
    await nextTick();
    if (!table) return;

    const header = table.getFlatHeaders().find((h) => h.column.id === columnId);

    if (!header) return;

    const element = document.querySelector(
        `th[data-header-id="${header.column.id}"]`,
    ) as HTMLElement | null;

    if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.width > 0) {
            const newSizing: ColumnSizingState = {
                ...table.getState().columnSizing,
                [columnId]: rect.width,
            };

            table.setColumnSizing(newSizing);
        }
    }
};
